type PencilIconProps = React.SVGProps<SVGSVGElement>;

const PencilIcon: React.FC<PencilIconProps> = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.3093 6.97595L25.024 11.6906M22.3093 4.97595C22.9345 4.35075 23.7825 3.99951 24.6667 3.99951C25.5508 3.99951 26.3988 4.35075 27.024 4.97595C27.6492 5.60115 28.0004 6.44911 28.0004 7.33328C28.0004 8.21746 27.6492 9.06541 27.024 9.69062L8.66667 28.048H4V23.2853L22.3093 4.97595Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export default PencilIcon;
